export default __webpack_public_path__ + "static/media/ProductSans-Medium.b2eb0341.svg";